import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=3031fb0e&"
import script from "./slider.js?vue&type=script&lang=js&"
export * from "./slider.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports